export default __webpack_public_path__ + "static/media/avatarwoman1.afca733d.png";